<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';
	import DeviceInList from '../Lists/Devices/DeviceInList.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<div class="mt-s mb-s">
	<Alert
		type="info"
		heading={$format('alert_heading_inclusion_device_is_already_present_title', {
			default: 'This device is already present in your account.',
		})}
		message={$format('alert_message_inclusion_device_is_already_present_text', {
			default: 'Do you want to proceed with inclusion?',
		})}
	/>
</div>
<DeviceInList {device} disableSelected />
